import { graphql } from "gatsby"
import React from "react"

import CtaBox from "@molecules/CtaBox/CtaBox"

const CtaBoxBlock = ({ blockDataCtaBox }) => {
  const { text, link } = blockDataCtaBox || {}
  return <CtaBox text={text} link={link} />
}

export const query = graphql`
  fragment CtaBox on WpBlockAcfCtaBox {
    __typename
    blockDataCtaBox {
      text
      link {
        target
        title
        url
      }
    }
  }
`
export default CtaBoxBlock
